import './Header.css';

const Header: React.FC = () => {
  return <h1>Зарплатный проект EMIVN</h1>;
};

export default Header;
